import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

import { User, UserList } from "../_models";

@Injectable({
  providedIn: "root",
})
export class GestaoUsuarioService {
  constructor(private http: HttpClient) {}

  insertUsuario(user: any) {
    return this.http.post<any>(`${environment.apiUrl}/api/user`, user);
  }

  userUpdate(user: any) {
    return this.http.put<any>(`${environment.apiUrl}/api/user`, user);
  }

  tempPasswordUsuario(userId: any) {
    return this.http.get<any>(`${environment.apiUrl}/api/user/temp/${userId}`);
  }

  getAllUsuarios() {
    return this.http.get<any>(`${environment.apiUrl}/api/user`);
  }

  getAllUsuariosPaged(page, size, sort, order, name, area, usertype) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/user/${page}/${size}?sort=${sort}&order=${order}&name=${name}&area=${area}&usertype=${usertype}`
    );
  }

  getUsersFiltered(
    page,
    size,
    sort,
    order,
    name,
    status,
    area,
    usertype,
    startDate,
    endDate
  ) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/user/search/${page}/${size}?sort=${sort}&order=${order}&name=${name}&status=${status}&area=${area}&usertype=${usertype}&startDate=${startDate}&endDate=${endDate}`
    );
  }

  editUsuario(user: User) {
    return this.http.put<User>(`${environment.apiUrl}/api/user/`, user);
  }

  // Métodos para usuários inativos
  getInactiveUsers(page: number, size: number, months: number = 24, sort?: string, order?: string) {
    let url = `${environment.apiUrl}/api/user/inactive/${page}/${size}?months=${months}`;
    if (sort && order) {
      url += `&sort=${sort}&order=${order}`;
    }
    return this.http.get<any>(url);
  }

  countInactiveUsers(months: number = 24) {
    return this.http.get<any>(`${environment.apiUrl}/api/user/inactive/count?months=${months}`);
  }

  deactivateInactiveUsers(months: number = 24) {
    return this.http.post<any>(`${environment.apiUrl}/api/user/deactivate-inactive?months=${months}`, {});
  }

  getNeverAccessedUsers(page: number, size: number, status?: string, sort?: string, order?: string) {
    const params: string[] = [];
    if (status && status !== 'TODOS') {
      params.push(`status=${status}`);
    }
    if (sort && order) {
      params.push(`sort=${sort}&order=${order}`);
    }
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return this.http.get<any>(`${environment.apiUrl}/api/user/never-accessed/${page}/${size}${queryString}`);
  }

  countNeverAccessedUsers() {
    return this.http.get<any>(`${environment.apiUrl}/api/user/never-accessed/count`);
  }

  deactivateNeverAccessedUsers() {
    return this.http.post<any>(`${environment.apiUrl}/api/user/deactivate-never-accessed`, {});
  }

  excluirUsuario(userId: number) {
    return this.http.delete<any>(`${environment.apiUrl}/api/user/delete/${userId}`);
  }
}
